module.exports = __webpack_public_path__ + "img/account.e95e2a8a.svg";